import { render } from "./StripeSetupModal.vue?vue&type=template&id=b2677cce"
import script from "./StripeSetupModal.vue?vue&type=script&lang=js"
export * from "./StripeSetupModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__